const jwtDecode = require('jwt-decode');

const isExpired = (token=null) => {
	if(token === null) { return true; }
	try {
		const decoded = jwtDecode(token);
		const current = Math.floor(new Date() / 1000);
		return current > decoded.exp;
	} catch(e) {
		console.error(e);
		return true;
	}
}

module.exports = isExpired;


// WEBPACK FOOTER //
// ./src/utils/checkToken.js